import { DocumentText as DocumentText_kojaro } from './DocumentText.kojaro';
import { DocumentText as DocumentText_phosphor } from './DocumentText.phosphor';
import { DocumentText as DocumentText_zoomg } from './DocumentText.zoomg';
import { DocumentText as DocumentText_zoomit } from './DocumentText.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return DocumentText_kojaro;

    case 'zoomg':
      return DocumentText_zoomg;

    case 'phosphor':
      return DocumentText_phosphor;

    default:
      return DocumentText_zoomit;
  }
};

export const DocumentText = IconRenderer();
